import CircularProgress from '@mui/material/CircularProgress';
import { useLoading } from '../layout/loading/useLoading';

interface LoadingSpinnerProps {
  fullPage?: boolean;
  message?: string;
  size?: number;
}

export function LoadingSpinner({ fullPage = false, message, size = 40 }: LoadingSpinnerProps) {
  useLoading(true);
  const content = (
    <div className="flex flex-col items-center gap-3">
      <CircularProgress size={size} />
      {message && <p className="text-sm text-gray-500">{message}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">{content}</div>
    );
  }

  return <div className="flex flex-1 items-center justify-center p-8">{content}</div>;
}
